import { useEffect, useRef } from "react";

/**
 * CursorSpotlight — adds a subtle radial gradient that follows the cursor
 * inside the wrapped section. Renders nothing if pointer is coarse (mobile).
 */
const CursorSpotlight = ({ color }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    // Disable on coarse pointer / reduced motion
    if (
      window.matchMedia("(pointer: coarse)").matches ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      return;
    }
    const parent = el.parentElement;
    if (!parent) return;
    parent.style.position = parent.style.position || "relative";

    let raf = 0;
    let tx = 0;
    let ty = 0;
    let x = 0;
    let y = 0;
    const move = (e) => {
      const r = parent.getBoundingClientRect();
      tx = e.clientX - r.left;
      ty = e.clientY - r.top;
      el.style.opacity = "1";
      if (!raf) raf = requestAnimationFrame(loop);
    };
    const leave = () => {
      el.style.opacity = "0";
    };
    const loop = () => {
      x += (tx - x) * 0.18;
      y += (ty - y) * 0.18;
      el.style.transform = `translate3d(${x - 200}px, ${y - 200}px, 0)`;
      raf = requestAnimationFrame(loop);
    };
    parent.addEventListener("mousemove", move);
    parent.addEventListener("mouseleave", leave);
    return () => {
      parent.removeEventListener("mousemove", move);
      parent.removeEventListener("mouseleave", leave);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      ref={ref}
      aria-hidden
      className="pointer-events-none absolute z-0 will-change-transform"
      style={{
        width: 400,
        height: 400,
        opacity: 0,
        transition: "opacity 400ms ease",
        background: `radial-gradient(circle, ${
          color || "var(--accent-blue-glow)"
        }, transparent 60%)`,
        filter: "blur(20px)",
        mixBlendMode: "screen",
      }}
    />
  );
};

export default CursorSpotlight;
